import styled from "styled-components";
import TextField from '@mui/material/TextField';
import {useState} from "react";
import SaveIcon from '@mui/icons-material/Save';
import api from '../../../axios.js'
import { estadoCuenta } from "../../../redux/actions/cuentasActions.js";
import LoadingButton from '@mui/lab/LoadingButton';
import {useDispatch} from 'react-redux'

const Container = styled.div`
	display:flex;
	justify-content: space-evenly;
	width:100%
`;

const ContainerButton = styled.div`
	display:flex;
	justify-content:center;
	align-items:center;
`;


const SubPanel = styled.div`
	display:flex;
	align-items:center;
	justify-content: space-between;
	margin:8px;
	width:32%;
`;


export default function NuevaCuenta(){
	const [loading,setLoading]=useState(false);
	const [cuenta,setCuenta]=useState({correo:"",playstation_id:""});
	let dispatch=useDispatch();


	let handleChange=(e)=>{
		let value=e.target.value;
		let name=e.target.name;
		setCuenta({...cuenta,[name]:value.trim()});
	}

	let save=async()=>{
			const flags = "gm";
			const pattern = "[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,}"
			const regexPattern = new RegExp(pattern, flags);
			const result = cuenta.correo.match(regexPattern);
		if(cuenta.correo&&cuenta.playstation_id&&result){
			if(window.confirm(`Desea crear la cuenta  con el correo ${cuenta.correo} y el id ${cuenta.playstation_id}`)){
				setLoading(true);
				dispatch(estadoCuenta(1))
				try{
					await api.post("/cuenta",cuenta);
					setLoading(false);
					setCuenta({correo:"",playstation_id:""});
					alert("cuenta creada con exito");
				}catch(err){
					console.log(err);
					alert("error al grabar cuenta");
					setLoading(false);			
				}
				dispatch(estadoCuenta(0));
			}
		}else{
			alert("error: datos incompletos")
		}
	}

	return(
		<Container>	
			<h4>Nueva Cuenta</h4>
			<ContainerButton>
				<LoadingButton loading={loading} startIcon={<SaveIcon />} variant="outlined"   onClick={save}> Save </LoadingButton >
			</ContainerButton>	  
      		
			<SubPanel>
				<div>Correo</div>
				<TextField size="small"  label="Correo"  type="search" variant="filled" name="correo" value={cuenta.correo} disabled={loading} sx={{width:"60%"}} onChange={handleChange} />		
			</SubPanel>
			<SubPanel>
				<div>playstation® ID</div>						
				<TextField  size="small" label="Playstation® ID" name="playstation_id" type="search" value={cuenta.playstation_id} variant="filled" disabled={loading} sx={{width:"60%"}} onChange={handleChange}/>		
			</SubPanel>	

		</Container>


		)
}